import moment from "moment";
import { getFullName, getAddress } from "../../util/helpers";
import {
  getLocalPhoneNumber,
  getAutoTableData,
  getPdfMargins,
} from "../../util/helpers";

export const getPlanItems = (employeeEvents) => {
  let tableData = [];
  let durations = {};
  if (employeeEvents && employeeEvents.length > 0) {
    employeeEvents.forEach((item, i) => {
      const startDate = moment()
        .startOf("day")
        .set("minute", item.start_time_minutes);
      const end = moment()
        .startOf("day")
        .set("minute", item.duration_minutes + item.start_time_minutes);
      const timeframe = end.format("HH:mm") + "-" + startDate.format("HH:mm");
      if (!tableData[0]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[0][item.weekday]) {
        tableData[0][item.weekday] = timeframe;
      } else if (!tableData[1]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[1][item.weekday]) {
        tableData[1][item.weekday] = timeframe;
      } else if (!tableData[2]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[2][item.weekday]) {
        tableData[2][item.weekday] = timeframe;
      } else if (!tableData[3]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[3][item.weekday]) {
        tableData[3][item.weekday] = timeframe;
      }
      durations[item.weekday] = durations[item.weekday]
        ? durations[item.weekday] + item.duration_minutes / 60
        : item.duration_minutes / 60;
      durations["total"] = durations["total"]
        ? durations["total"] + item.duration_minutes / 60
        : item.duration_minutes / 60;
    });
  }

  if (durations["total"]) {
    let rounded = {};
    Object.keys(durations).map(
      (key) => (rounded[key] = Math.round(durations[key] * 100) / 100)
    );
    tableData.push(rounded);
  }

  let final = [];
  tableData.forEach((item, i) => {
    const temp = {
      total: item["total"],
      satuarday: item["6"],
      friday: item["5"],
      thursday: item["4"],
      wednesday: item["3"],
      tuesday: item["2"],
      monday: item["1"],
      sunday: item["0"],
    };
    final.push(temp);
  });
  return final;
};

export const getManualItems = (manualEvents) => {
  let tableData = [];
  let final = [];
  if (manualEvents && manualEvents.length > 0) {
    manualEvents.forEach((item, i) => {
      const startDate = moment(item.date);
      const end = moment(startDate).add(item.duration_minutes, "minutes");
      const date = moment(item.date).format("D/M");
      const timeframe =
        date + " " + end.format("HH:mm") + "-" + startDate.format("HH:mm");
      if (i < 7) {
        if (!tableData[0]) {
          tableData.push({
            [i]: timeframe,
          });
        } else {
          tableData[0][i] = timeframe;
        }
      } else if (i < 14) {
        if (!tableData[1]) {
          tableData.push({
            [i - 7]: timeframe,
          });
        } else {
          tableData[1][i - 7] = timeframe;
        }
      } else if (i < 21) {
        if (!tableData[2]) {
          tableData.push({
            [i - 14]: timeframe,
          });
        } else {
          tableData[2][i - 14] = timeframe;
        }
      } else if (i < 28) {
        if (!tableData[3]) {
          tableData.push({
            [i - 21]: timeframe,
          });
        } else {
          tableData[3][i - 21] = timeframe;
        }
      }
    });
  }

  if (tableData.length > 0 && tableData.length < 7) {
    var j;
    for (j = manualEvents.length; j < 7; j++) {
      tableData[0][j] = "";
    }
  }
  if (tableData.length > 0) {
    tableData.forEach((item, i) => {
      const temp = {
        satuarday: item["6"],
        friday: item["5"],
        thursday: item["4"],
        wednesday: item["3"],
        tuesday: item["2"],
        monday: item["1"],
        sunday: item["0"],
      };
      final.push(temp);
    });
  }

  return final;
};

const setEntityContent = (
  doc,
  hLoc,
  marginTop,
  title,
  content,
  contentMargin,
  width
) => {
  if (content && content.length > 0) {
    doc.setFontSize(13);
    doc.text(title, hLoc - 2, marginTop + 7, {
      align: "right",
    });
    content.forEach((item, i) => {
      if (item.type === "title") {
        doc.setFontSize(12);
        doc.setFont("Rubik", "bold");
      } else {
        doc.setFontSize(9);
        doc.setFont("Rubik", "normal");
      }
      const topMargin = contentMargin
        ? contentMargin + i * 4
        : marginTop + 13 + i * 4;
      if (item.type === "checkbox") {
        doc.setLineDashPattern([1, 0]);
        // doc.setFillColor(217, 217, 217);
        doc.setDrawColor(217);

        doc.roundedRect(hLoc - 6, topMargin - 4, 3.5, 3.5, 0.5, 0.5);
      } else {
        var splitValue = doc.splitTextToSize(item.value, width);
        if (splitValue[1] && item.type === "title") {
          doc.setFontSize(9);
          const isHebrew = (text) => {
            return text.search(/[\u0590-\u05FF]/) >= 0;
          };
          const first = isHebrew(splitValue[0]) ? 0 : 1;
          const last = isHebrew(splitValue[0]) ? 1 : 0;
          doc.text(splitValue[first], hLoc - 2, topMargin - 2, {
            align: "right",
          });
          doc.text(splitValue[last], hLoc - 2, topMargin + 1, {
            align: "right",
          });
        } else {
          doc.text(splitValue[0], hLoc - 2, topMargin, {
            align: "right",
          });
        }
      }
    });
  }
};

export const getMonthlyItems = (
  holidays,
  currentDate,
  shouldRenderHours,
  allEvents
) => {
  let tableData = [];
  const numberOfDays = moment(currentDate).daysInMonth();
  var i;
  for (i = 0; i < numberOfDays; i++) {
    const currentDay = moment(currentDate).startOf("month").add(i, "days");
    const weekDay = currentDay.weekday();
    const isHoliday = holidays.filter(
      (item) => moment(item.date).date() === i + 1
    )[0];

    // rowSpan
    let span = 0;
    if (weekDay === 0 || i + 1 === 1) {
      span = 7 - weekDay;
    }

    if (weekDay > 0 && i + 1 !== 1) {
      span = 0;
    }

    const dayEvents = allEvents.filter(
      (j) =>
        moment(j.date) >= currentDay.startOf("day") &&
        moment(j.date) <= currentDay.endOf("day")
    );
    const durationInMinutes = dayEvents.reduce((accumulator, object) => {
      return accumulator + object.duration_minutes;
    }, 0);

    const duration =
      durationInMinutes !== 0 && shouldRenderHours
        ? Math.round((durationInMinutes / 60) * 100) / 100
        : "";

    const entrance1 =
      dayEvents[0] && shouldRenderHours
        ? moment(dayEvents[0].date).format("HH:mm")
        : "";
    const entrance2 =
      dayEvents[1] && shouldRenderHours
        ? moment(dayEvents[1].date).format("HH:mm")
        : "";
    const exit1 =
      dayEvents[0] && shouldRenderHours
        ? moment(dayEvents[0].date)
            .add(dayEvents[0].duration_minutes, "minutes")
            .format("HH:mm")
        : "";
    const exit2 =
      dayEvents[1] && shouldRenderHours
        ? moment(dayEvents[1].date)
            .add(dayEvents[1].duration_minutes, "minutes")
            .format("HH:mm")
        : "";

    tableData.push({
      weeklySignature: { content: "", rowSpan: span },
      careGiverSignature: { content: "" },
      sum: { content: duration },
      exit2: { content: exit2 },
      entrance2: { content: entrance2 },
      exit1: { content: exit1 },
      entrance1: { content: entrance1 },
      holiday: {
        content:
          isHoliday !== undefined
            ? isHoliday.holiday_evening
              ? "ע.חג"
              : "חג"
            : "",
      },
      day: { content: moment.weekdays(weekDay) },
      number: { content: i + 1 },
    });
  }
  return tableData;
};

export const setDiaryHeader = (intl, doc, record) => {
  const margins = getPdfMargins(doc);
  const organizationName = record.organization.name;
  const phone =
    record.branch && record.branch.phone_number
      ? getLocalPhoneNumber(record.branch.phone_number)
      : null;
  const mobile =
    record.branch && record.branch.mobile_number
      ? getLocalPhoneNumber(record.branch.mobile_number)
      : null;
  const fax_number =
    record.branch && record.branch.fax_number
      ? getLocalPhoneNumber(record.branch.fax_number)
      : null;
  const selectedClientName = !record?.record?.order
    ? ""
    : record.record.order &&
      record.record.order.client &&
      record.record.order.client.name;
  const address = getAddress(record.branch.address);
  const from = `מאת: ${organizationName} - ${record.branch.name}`;
  const to = `${intl.formatMessage({
    id: `app.work_diary_print.to`,
  })} ${selectedClientName}`;
  const title = `${intl.formatMessage({
    id: `app.work_diary_print.title`,
  })} ${moment(record.currentDate).format("MM/YYYY")}`;
  const phoneText = phone ? `טלפון: ${phone}` : ``;
  const mobileText = mobile ? `סלולארי: ${mobile}` : ``;
  const faxText = fax_number ? `פקס: ${fax_number}` : ``;
  const addressText = address ? `כתובת: ${address}` : ``;
  doc.setFontSize(9);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font

  var hLoc = doc.internal.pageSize.getWidth() - margins;
  doc.text(from, hLoc, 20, {
    align: "right",
  });
  doc.setFont("Rubik", "bold");
  doc.text(to, hLoc, 24, {
    align: "right",
  });
  doc.setFont("Rubik", "normal");
  doc.text(phoneText, margins, 20, {
    align: "left",
  });
  doc.text(mobileText, margins, 23.5, {
    align: "left",
  });
  doc.text(faxText, margins, 27, {
    align: "left",
  });

  doc.text(addressText, margins, 30.5, {
    align: "left",
  });
  const logo = record.logo;

  if (logo) {
    doc.addImage(
      logo,
      "png",
      doc.internal.pageSize.getWidth() / 2 - margins,
      12,
      (12 / logo.height) * logo.width,
      12
    );
  }
  doc.setFontSize(14);
  doc.setFont("Rubik", "bold");
  doc.text(title, hLoc, 29, {
    align: "right",
  });
  doc.setFont("Rubik", "normal");
};

export const setPlan = (intl, doc, planEvents, manualEvents) => {
  let planData = getPlanItems(planEvents);
  if (planData.length === 0 && manualEvents.length === 0) {
    // Create dummy plan with undefined values
    planData = [
      {
        total: undefined,
        satuarday: undefined,
        friday: undefined,
        thursday: undefined,
        wednesday: undefined,
        tuesday: undefined,
        monday: undefined,
        sunday: undefined,
      },
      {
        total: undefined,
        satuarday: undefined,
        friday: undefined,
        thursday: undefined,
        wednesday: undefined,
        tuesday: undefined,
        monday: undefined,
        sunday: undefined,
      },
    ];
  }
  if (planData.length === 0) {
    setManualScheduling(intl, doc, manualEvents);
  } else {
    const margins = getPdfMargins(doc);
    const netoWidth = doc.internal.pageSize.getWidth() - margins * 2;
    const width = netoWidth / 8;
    let columnStyles = {
      0: { cellWidth: width },
      1: { cellWidth: width },
      2: { cellWidth: width },
      3: { cellWidth: width },
      4: { cellWidth: width },
      5: { cellWidth: width },
      6: { cellWidth: width },
      7: { cellWidth: width },
    };
    const plan = {
      ...getAutoTableData(planData, intl, "diary"),
      didParseCell: function (data) {
        const isHebrew = (text) => {
          return text.search(/[\u0590-\u05FF]/) >= 0;
        };
        if (!isHebrew(data.cell.text[0])) {
          data.cell.text = data.cell.text[0].split("").reverse().join("");
        }
      },
      columnStyles,
      styles: {
        fontSize: 9,
        font: "Rubik",
        halign: "right",
        overflow: "linebreak",
        lineColor: [40],
        lineWidth: 0.3,
        cellPadding: 0.5,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 40,
      },
      startY: 69,
      theme: "grid",
    };
    doc.autoTable(plan);
  }
};

export const setManualScheduling = (intl, doc, manualEvents) => {
  const manualData = getManualItems(manualEvents);
  const margins = getPdfMargins(doc);
  const netoWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const width = netoWidth / 7;
  let columnStyles = {
    0: { cellWidth: width, fillColor: [255, 255, 255] },
    1: { cellWidth: width, fillColor: [255, 255, 255] },
    2: { cellWidth: width, fillColor: [255, 255, 255] },
    3: { cellWidth: width, fillColor: [255, 255, 255] },
    4: { cellWidth: width, fillColor: [255, 255, 255] },
    5: { cellWidth: width, fillColor: [255, 255, 255] },
    6: { cellWidth: width, fillColor: [255, 255, 255] },
  };
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  if (manualEvents.length < 22) {
    //Add header when there are only 3 rows in the table
    doc.setFontSize(11);
    doc.setTextColor(40);
    doc.setR2L(true);
    doc.setFont("Rubik", "bold");
    doc.text("מועדי שיבוצים", hLoc, 69, {
      align: "right",
    });
  }

  const plan = {
    ...getAutoTableData(manualData, intl, "diary"),
    didParseCell: function (data) {
      data.cell.text = data.cell.text[0].split("").reverse().join("");
    },
    columnStyles,
    styles: {
      fontSize: 8,
      font: "Rubik",
      halign: "right",
      valign: "middle",
      overflow: "linebreak",
      lineColor: [40],
      lineWidth: 0.3,
      cellPadding: 0.5,
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: 40,
    },
    showHead: "never",
    startY: manualEvents.length < 22 ? 70 : 67,
    theme: "grid",
  };
  doc.autoTable(plan);
};

export const setDiaryTopContent = (doc, record, intl) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik");
  const margins = getPdfMargins(doc);

  setEntitiesBorders(doc, margins);
  setPatientContent(record, doc, margins, intl);
  setEmployeeContent(record, doc, margins, intl);
  setExtraDetailsContent(record, doc, margins, intl);
  setNonServiceContent(record, doc, margins, intl);
};

const setEntitiesBorders = (doc, margins) => {
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const netoContainersWidth = netoPageWidth - 6;
  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0.5, 0.5]);
  const patientCordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    (netoContainersWidth * 4.5) / 20;
  doc.rect(patientCordinate, 32, (netoContainersWidth * 4.5) / 20, 36);
  const employeeCordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    (netoContainersWidth * 9) / 20 -
    2;
  doc.rect(employeeCordinate, 32, (netoContainersWidth * 4.5) / 20, 36);
  const additionalCordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    (netoContainersWidth * 14.5) / 20 -
    4;
  doc.rect(additionalCordinate, 32, (netoContainersWidth * 5.5) / 20, 36);
  const nonServiceCordinate = margins;
  doc.rect(nonServiceCordinate, 32, (netoContainersWidth * 5.5) / 20, 36);
};

const containsOnlyNumbers = (str) => {
  return /^\d+$/.test(str);
};

const setPatientContent = (record, doc, margins, intl) => {
  const { patient } = record;
  const patient_id = patient?.id;
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  // Determine which address to use
  const addressToUse = patient?.has_temporary_address
    ? patient?.temporary_address
    : patient?.address;

  const houseNumber = addressToUse?.house_number?.trim();
  const apartmentNumber = addressToUse?.apartment_number?.trim();
  const fullHouseNumber =
    houseNumber && apartmentNumber
      ? `${houseNumber}/${apartmentNumber}`
      : houseNumber
      ? houseNumber
      : "";

  const street = addressToUse?.street
    ? `${
        containsOnlyNumbers(addressToUse.street.trim())
          ? addressToUse.street.trim().toString().split("").reverse().join("")
          : addressToUse.street.trim()
      } ${fullHouseNumber}`
    : "-";
  const city = addressToUse?.city !== undefined ? addressToUse.city : "-";

  const fullName = getFullName(patient.surename, patient.first_name);
  const patientContent = [
    {
      type: "title",
      value: !patient_id ? "" : fullName,
    },
    {
      title: "detail",
      value: !patient_id
        ? ""
        : patient && patient.id
        ? patient.id.toString().split("").reverse().join("")
        : "-",
    },
    {
      title: "detail",
      value: !patient_id
        ? ""
        : patient && patient.local_id_number
        ? patient.local_id_number.toString().split("").reverse().join("")
        : "-",
    },
    {
      title: "detail",
      value: !patient_id ? "" : city,
    },
    {
      title: "detail",
      value: !patient_id ? "" : street,
    },
    {
      title: "detail",
      value: !patient_id
        ? ""
        : patient &&
          patient.contact_info &&
          (patient.contact_info.mobile_number ||
            patient.contact_info.phone_number)
        ? getLocalPhoneNumber(
            patient.contact_info.mobile_number
              ? patient.contact_info.mobile_number
              : patient.contact_info.phone_number
          )
            .split("")
            .reverse()
            .join("")
        : "-",
    },
  ];
  return setEntityContent(doc, hLoc, 30, "פרטי הזכאי", patientContent, 0, 36);
};

const setEmployeeContent = (record, doc, margins, intl) => {
  const { employee } = record.record;
  const street =
    employee && employee["address"] && employee["address"]["street"]
      ? `${
          containsOnlyNumbers(employee.address.street.trim())
            ? employee.address.street
                .trim()
                .toString()
                .split("")
                .reverse()
                .join("")
            : employee.address.street.trim()
        } ${employee["address"]["house_number"]}`
      : "-";
  const city =
    employee && employee["address"] && employee["address"]["city"] !== undefined
      ? employee["address"]["city"].trim()
      : "-";
  const fullName = employee
    ? getFullName(employee.surename, employee.first_name)
    : "-";

  const phoneNum =
    employee && employee.contact_info
      ? getLocalPhoneNumber(
          employee.contact_info.mobile_number
            ? employee.contact_info.mobile_number
            : employee.contact_info.phone_number
        )
      : null;

  const isHebrew = (text) => {
    return text.search(/[\u0590-\u05FF]/) >= 0;
  };

  const employeeContent = [
    {
      type: "title",
      value: !employee
        ? ""
        : isHebrew(fullName)
        ? fullName
        : fullName.split("").reverse().join(""),
    },
    {
      title: "detail",
      value: !employee
        ? ""
        : employee.accounting_info && employee.accounting_info.number
        ? employee.accounting_info.number
            .toString()
            .split("")
            .reverse()
            .join("")
        : "-",
    },
    {
      title: "detail",
      value: !employee
        ? ""
        : employee && employee.local_id_number
        ? employee.local_id_number.toString().split("").reverse().join("")
        : "-",
    },
    {
      title: "detail",
      value: !employee ? "" : city,
    },
    {
      title: "detail",
      value: !employee ? "" : street,
    },
    {
      title: "detail",
      value: !employee
        ? ""
        : phoneNum
        ? phoneNum.split("").reverse().join("")
        : "-",
    },
  ];
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const width = ((netoPageWidth - 6) * 4.5) / 20;
  var hLoc = doc.internal.pageSize.getWidth() - width - 2 - margins;

  return setEntityContent(
    doc,
    hLoc,
    30,
    intl.formatMessage({
      id: "app.work_diary_print.employee_details",
    }),
    employeeContent,
    0,
    36
  );
};

const setExtraDetailsContent = (record, doc, margins, intl) => {
  const { employee, order, staff_worker_in_charge } = record.record;
  const { patient, totalHours } = record;

  var age = employee ? moment().diff(employee.birthday, "years") : null;
  const isPensioner =
    employee &&
    ((employee.gender_id === 1 && age >= 67) ||
      (employee.gender_id === 2 && age >= 62));

  let isRelative = false;
  if (
    employee &&
    patient &&
    patient.relative_employees &&
    patient.relative_employees.length > 0
  ) {
    patient.relative_employees.forEach((item, i) => {
      if (item === employee.id) {
        isRelative = true;
      }
    });
  }
  const extraRightContent = [
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.employee.staff_worker_in_charge_id",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.pensioner",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.relative",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.effective_from",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.effective_to",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.max_hours_per_month",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.totalHours",
      }),
    },
  ];

  const extraLeftContent = [
    {
      title: "detail",
      value: !employee
        ? ""
        : staff_worker_in_charge
        ? getFullName(
            staff_worker_in_charge.surename,
            staff_worker_in_charge.first_name
          )
        : "-",
    },
    {
      title: "detail",
      value: !employee ? "" : isPensioner ? "כן" : "לא",
    },
    {
      title: "detail",
      value: !employee ? "" : isRelative ? "כן" : "לא",
    },
    {
      title: "detail",
      value: !order
        ? ""
        : order?.effective_from
        ? moment(order.effective_from)
            .format("DD/MM/YYYY")
            .toString()
            .split("")
            .reverse()
            .join("")
        : "",
    },
    {
      title: "detail",
      value: !order
        ? ""
        : order?.effective_to
        ? moment(order.effective_to)
            .format("DD/MM/YYYY")
            .toString()
            .split("")
            .reverse()
            .join("")
        : "ללא תאריך סיום",
    },
    {
      title: "detail",
      value: !order
        ? ""
        : order?.max_hours_per_month
        ? order.max_hours_per_month.toString().split("").reverse().join("")
        : "-",
    },
    {
      title: "detail",
      value:
        !totalHours || totalHours === 0
          ? "-"
          : totalHours.toString().split("").reverse().join(""),
    },
  ];
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const width = ((netoPageWidth - 6) * 9) / 20;

  var hLoc = doc.internal.pageSize.getWidth() - width - 4 - margins;

  setEntityContent(
    doc,
    hLoc,
    30,
    intl.formatMessage({
      id: "app.work_diary_print.additional_details",
    }),
    extraRightContent,
    42,
    27
  );

  setEntityContent(doc, hLoc - 22, 30, "", extraLeftContent, 42, 27);
};

const setNonServiceContent = (record, doc, margins, intl) => {
  const checkboxContent = [
    {
      type: "checkbox",
    },
    {
      type: "checkbox",
    },
    {
      type: "checkbox",
    },
    {
      type: "checkbox",
    },
    {
      type: "checkbox",
    },
    {
      type: "checkbox",
    },
  ];

  const leftContent = [
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.middleOfWeekReason",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.terminationReason",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.demise",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.hospitalization",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.absence",
      }),
    },
    {
      title: "detail",
      value: intl.formatMessage({
        id: "app.work_diary_print.other",
      }),
    },
  ];

  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const width = ((netoPageWidth - 6) * 14.5) / 20;

  var hLoc = doc.internal.pageSize.getWidth() - width - 6 - margins;

  setEntityContent(
    doc,
    hLoc,
    30,
    intl.formatMessage({
      id: "app.work_diary_print.nonServiceReasons",
    }),
    checkboxContent,
    0,
    36
  );
  return setEntityContent(doc, hLoc - 5, 30, "", leftContent, 42, 36);
};

export const setDiaryBottomContent = (
  doc,
  record,
  setHeader,
  headerRecord,
  intl
) => {
  const margins = getPdfMargins(doc);
  let finalY = doc.lastAutoTable.finalY;
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  setDailyPlanComments(doc, intl, finalY + 5, hLoc);
  setApprovals(doc, intl, finalY + 11, hLoc, headerRecord);
  setStatements(doc, intl, finalY + 29, hLoc, headerRecord);
};

const setDailyPlanComments = (doc, intl, finalY, hLoc) => {
  doc.setFontSize(9);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  doc.text(
    intl.formatMessage({
      id: "app.work_diary_print.comments",
    }),
    hLoc,
    finalY,
    {
      align: "right",
    }
  );

  doc.setDrawColor(40);
  doc.setLineWidth(0.3);
  doc.line(hLoc - 27, finalY, hLoc - 94, finalY);
  doc.text(
    intl.formatMessage({
      id: "app.work_diary_print.hours_count",
    }),
    hLoc - 96,
    finalY,
    {
      align: "right",
    }
  );
  doc.line(hLoc - 112, finalY, hLoc - 122, finalY);
  doc.text(
    intl.formatMessage({
      id: "app.work_diary_print.driving",
    }),
    hLoc - 124,
    finalY,
    {
      align: "right",
    }
  );
  doc.line(hLoc - 134, finalY, hLoc - 144, finalY);
  doc.setDrawColor(217);
  doc.roundedRect(hLoc - 150, finalY - 3.5, 3.5, 3.5, 0.5, 0.5);
  doc.text(
    intl.formatMessage({
      id: "app.work_diary_print.free_monthly",
    }),
    hLoc - 152,
    finalY,
    {
      align: "right",
    }
  );
  doc.setDrawColor(40);
  doc.line(hLoc - 169, finalY, hLoc - 182, finalY);
};

const setApprovals = (doc, intl, finalY, hLoc, record) => {
  const { employee } = record.record;
  const fullName = employee
    ? getFullName(employee.surename, employee.first_name)
    : "לא קיים";
  const familyMemberFirstLine = [
    intl.formatMessage({
      id: "app.work_diary_print.name",
    }),
    intl.formatMessage({
      id: "app.work_diary_print.relative_relation",
    }),
  ];
  const familyMemberSecondLine = ["line", "line"];

  const careGiverFirstLine = [
    intl.formatMessage({
      id: "app.work_diary_print.name",
    }),
    intl.formatMessage({
      id: "app.work_diary_print.signature",
    }),
    intl.formatMessage({
      id: "app.work_diary_print.date",
    }),
  ];

  const isHebrew = (text) => {
    return text.search(/[\u0590-\u05FF]/) >= 0;
  };

  const careGiverSecondLine = [
    isHebrew(fullName) ? fullName : fullName.split("").reverse().join(""),
    "line",
    "line",
  ];

  const companyFirstLine = [
    intl.formatMessage({
      id: "app.work_diary_print.company_signature",
    }),
    intl.formatMessage({
      id: "app.work_diary_print.date",
    }),
  ];
  const companySecondLine = ["line", "line"];

  setApprovalSection(
    doc,
    intl,
    finalY,
    hLoc,
    "family_member",
    familyMemberFirstLine,
    familyMemberSecondLine,
    2 / 7,
    2 / 7,
    0
  );

  setApprovalSection(
    doc,
    intl,
    finalY,
    hLoc,
    "caregiver_approval",
    careGiverFirstLine,
    careGiverSecondLine,
    3 / 7,
    5 / 7,
    2
  );
  setApprovalSection(
    doc,
    intl,
    finalY,
    hLoc,
    "company_approval",
    companyFirstLine,
    companySecondLine,
    2 / 7,
    1,
    4
  );
};

const setApprovalSection = (
  doc,
  intl,
  finalY,
  hLoc,
  name,
  firstLine,
  secondLine,
  ratio,
  rightRatio,
  rightMargin
) => {
  const margins = getPdfMargins(doc);
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const netoContainersWidth = netoPageWidth - 4;
  const coordinate =
    doc.internal.pageSize.getWidth() -
    margins -
    rightRatio * netoContainersWidth -
    rightMargin;
  const textHloc = coordinate + ratio * netoContainersWidth - 1;
  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0.5, 0.5]);
  doc.rect(coordinate, finalY - 3, netoContainersWidth * ratio, 16);
  doc.setFontSize(11);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "bold");
  doc.text(
    intl.formatMessage({
      id: `app.work_diary_print.${name}`,
    }),
    textHloc,
    finalY + 1,
    {
      align: "right",
    }
  );
  doc.setFontSize(9);
  doc.setFont("Rubik", "normal");

  const numberOfItems = firstLine.length;
  const spaces = (numberOfItems - 1) * 2;
  var i;
  const sectionWidth = ratio * (netoContainersWidth - spaces);
  const fieldWidth =
    (1 / firstLine.length) * (sectionWidth - 4 - 2 * (firstLine.length - 1));

  for (i = 0; i < firstLine.length; i++) {
    const rightPosition = textHloc - (sectionWidth * i) / numberOfItems;
    doc.text(firstLine[i], rightPosition, finalY + 6, {
      align: "right",
    });
    doc.setLineDashPattern([1, 0]);
  }

  for (i = 0; i < secondLine.length; i++) {
    const rightPosition = textHloc - (sectionWidth * i) / numberOfItems;
    if (secondLine[i] === "line") {
      doc.setLineDashPattern([1, 0]);
      doc.line(
        rightPosition,
        finalY + 11,
        rightPosition - fieldWidth,
        finalY + 11
      );
    } else {
      var splitValue = doc.splitTextToSize(secondLine[i], fieldWidth);
      doc.text(splitValue[0], rightPosition, finalY + 11, {
        align: "right",
      });
    }
  }
};

const setStatements = (doc, intl, finalY, hLoc, headerRecord) => {
  const work_in_other_company =
    headerRecord?.record?.employee?.work_in_other_company;
  const margins = getPdfMargins(doc);
  const netoPageWidth = doc.internal.pageSize.getWidth() - margins * 2;
  const coordinate = margins;
  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.setLineDashPattern([0.5, 0.5]);
  doc.rect(coordinate, finalY - 3, netoPageWidth, 16);
  doc.setFontSize(11);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "bold");
  doc.text(
    intl.formatMessage({
      id: `app.work_diary_print.employee_statements`,
    }),
    hLoc - 1,
    finalY + 1,
    {
      align: "right",
    }
  );

  doc.setFontSize(9);
  doc.setFont("Rubik", "normal");
  setSingleStatement(
    doc,
    intl,
    finalY + 6,
    hLoc - 1,
    (netoPageWidth * 15) / 36 - 2,
    56,
    intl.formatMessage({
      id: `app.work_diary_print.no_reltive_statement`,
    })
  );

  setSingleStatement(
    doc,
    intl,
    finalY + 6,
    hLoc - 3 - (netoPageWidth * 15) / 36,
    (netoPageWidth * 21) / 36 - 4,
    85,
    intl.formatMessage({
      id: `app.work_diary_print.filled_reltive_statement`,
    })
  );

  setSingleStatement(
    doc,
    intl,
    finalY + 11,
    hLoc - 1,
    (netoPageWidth * 15) / 36 - 2,
    56,
    intl.formatMessage({
      id: `app.work_diary_print.no_other_company_statement`,
    }),
    !work_in_other_company
  );

  setSingleStatement(
    doc,
    intl,
    finalY + 11,
    hLoc - 3 - (netoPageWidth * 15) / 36,
    (netoPageWidth * 21) / 36 - 4,
    85,
    intl.formatMessage({
      id: `app.work_diary_print.other_company_statement`,
    }),
    work_in_other_company
  );

  doc.text(
    intl.formatMessage({
      id: `app.work_diary_print.family_member_description`,
    }),
    hLoc - 1,
    finalY + 17,
    {
      align: "right",
    }
  );
};

const setSingleStatement = (
  doc,
  intl,
  finalY,
  hLoc,
  width,
  startLine,
  text,
  checked = false
) => {
  doc.setLineDashPattern([1, 0]);
  doc.setDrawColor(217);
  doc.roundedRect(hLoc - 4, finalY - 3, 3.5, 3.5, 0.5, 0.5);

  if (checked) {
    // Draw checkmark
    doc.setDrawColor(40); // Set color to dark gray
    doc.setLineWidth(0.3);
    // Draw the checkmark as two lines
    doc.line(hLoc - 3.5, finalY - 1.5, hLoc - 2.5, finalY - 0.5); // First line (shorter)
    doc.line(hLoc - 2.5, finalY - 0.5, hLoc - 1, finalY - 2.5); // Second line (longer)
  }

  doc.text(text, hLoc - 6, finalY, {
    align: "right",
  });
  doc.setLineWidth(0.3);
  doc.setDrawColor(40);
  doc.line(hLoc - startLine, finalY, hLoc - width, finalY);
};
